<script lang="ts" setup>
  import useForm from "~/composables/use-form";

  const newsletterForm: any = await useAcfOptions('newsletter_form');

  const props = defineProps<{
    isEnabled: boolean
    overFlowSection?:boolean
  }>();

  const form: any = await useForm(`${newsletterForm?.form_id}`);
  const route = useRoute();

  let overflowClass = '';

  if (route.path.toString() === '/' || route.path.toString() === '/about-us' || route.path.toString() === '/about-us/' || props?.overFlowSection) {
    overflowClass = 'top-overflow-mobile';
  }
</script>
<template>
  <div :class="`w-100 bg-primary rounded-top-5 newsletter-div pt-5 container-fluid ${overflowClass}`">
    <div class="container-xl">
      <div class="col-12 d-flex justify-content-center mb-5">
        <h1 class="text-secondary">{{ newsletterForm?.heading }}</h1>
      </div>
      <div class="col-12 bg-secondary p-5 px-md-5 px-4 rounded-5">
        <div class="row">
          <div class="col-12 col-md-4 pe-md-5 mb-3">
            <h1 class="text-primary mb-4">{{ newsletterForm?.title }}</h1>
            <div v-html="newsletterForm?.description"></div>
          </div>
          <div class="col-12 col-md-8">
            <GravityForm :formObj="form" formId="newsletter-form"
                         :gravityFormId="parseInt(newsletterForm?.form_id)"
                         :reversedBtnHover="true"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
